const $ = require("jquery");
import 'slick-carousel';

(function () {
    var $slickMobile = $("[data-js-slick-mobile]");


    function slickIt($element) {
        $element.each(function () {
            $(this).not('.slick-initialized').slick({
                infinite: false,
                speed: 300,
                slidesToShow: 1.05,
                slidesToScroll: 1,
                dots: true,
                arrows: false,
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: "unslick"
                    }
                ]
            });
        });
    }

    slickIt($slickMobile);
})();